import React from "react";
import { Stack, Typography } from "@mui/material";

import SchedulerContextMenu from "./SchedulerContextMenu";
import { StyledGoalStack } from "./styles";
import { HubButtonGroupSlider } from "../../components/HubButtonGroupSlider";

const ViewTypes = [
  { id: 0, label: "Hours" },
  { id: 1, label: "Revenue" },
];
const SchedulerGoals = ({
  view = 0,
  setView = () => {},
  showLabels = false,
  onToggleLabels = () => {},
  showSuggestions = false,
  onSuggestReschedule = () => {},
}) => {
  return (
    <StyledGoalStack>
      <Typography variant="caption">Work Order By Target Percentage</Typography>
      <Stack direction="row" gap="15px" alignItems="center">
        <HubButtonGroupSlider
          buttons={ViewTypes}
          selected={Number(!!view)}
          setSelected={setView}
        />
        <SchedulerContextMenu
          showLabels={showLabels}
          onToggleLabels={onToggleLabels}
          showSuggestions={showSuggestions}
          onSuggestReschedule={onSuggestReschedule}
        />
      </Stack>
    </StyledGoalStack>
  );
};

export default SchedulerGoals;
